import React from 'react';
import styled from 'styled-components';
import { Tag, Input, type SelectProps } from 'antd';

type ITagRender = Parameters<NonNullable<SelectProps['tagRender']>>[number];

type InputTagProps = {
  onChange: (key: string, value: string) => boolean;
} & ITagRender;

const StyledTag = styled(Tag)`
  position: relative;
  padding-right: 16px;
  margin: 0;
  font-size: 14px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  span.ant-tag-close-icon {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const handleStopPropagation = (e: React.BaseSyntheticEvent) => e.stopPropagation();

// label and value are same in this case
// input change value and keep label as original, use label to update select's value array
const InputTag = ({ label, value, closable, onClose, onChange }: InputTagProps) => {
  const [editing, setEditing] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(value);

  const handleInputConfirm = React.useCallback(() => {
    const successed = onChange(label?.toString() || '', inputValue);
    setEditing(!successed);
  }, [label, inputValue, onChange]);

  if (editing) {
    return (
      <Input
        size="small"
        value={inputValue}
        autoFocus // disable antd select always focus on the last tag
        style={{ width: 240 }}
        onKeyDown={handleStopPropagation} // editing disable antd select deleting
        onMouseDown={handleStopPropagation}
        onClick={handleStopPropagation}
        onBlur={handleInputConfirm}
        onPressEnter={handleInputConfirm}
        onChange={(e) => setInputValue(e.target.value)}
      />
    );
  }

  return (
    <StyledTag
      closable={closable}
      title={label as string}
      onClose={onClose}
      onMouseDown={(e) => {
        e.preventDefault(); // disable antd select render options panel
        e.stopPropagation();
      }}
      onClick={() => setEditing(true)}
    >
      {label}
    </StyledTag>
  );
};

export default React.memo(InputTag);
